import { useEffect } from 'react';
import { onlyRenderWhenAuthenticated } from 'App/Session';
import { isExtensionPanel } from './panelContext';

// Inside the extension side-panel iframe the only surface is the AI chat. Once the
// user is authenticated (e.g. after logging in within the panel, which otherwise
// drops them on the regular CRM start page), force the embed route so they land on
// the chat. Renders nothing; no-op when not framed (i.e. the normal CRM). WEB-7101.
const PanelRedirect = onlyRenderWhenAuthenticated(() => {
	useEffect(() => {
		// Run on mount AND on every hash change: the post-login start-page redirect
		// can land after this mounts, so a one-shot check would miss it.
		const enforce = () => {
			if (!isExtensionPanel()) return;
			const path = window.location.hash.replace(/^#/, '');
			if (!path.startsWith('/embed/ai-chat')) {
				window.location.hash = '#/embed/ai-chat';
			}
		};
		enforce();
		window.addEventListener('hashchange', enforce);
		return () => window.removeEventListener('hashchange', enforce);
	}, []);

	return null;
});

export default PanelRedirect;
